import { getTokenSubject } from './refreshTokenSession';

export type LoginSession = { subject: string; generation: string };
export const LOGIN_SESSION_STORAGE_KEY = 'productionMonitoringSession';

export const isLoginSession = (value: unknown): value is LoginSession => {
  const session = value as Partial<LoginSession> | null;
  return (
    typeof session?.subject === 'string' &&
    !!session.subject &&
    typeof session.generation === 'string' &&
    !!session.generation
  );
};

export const sameLoginSession = (first: LoginSession | null, second: LoginSession | null): boolean =>
  !!first && !!second && first.subject === second.subject && first.generation === second.generation;

export const getLoginSession = (): LoginSession | null => {
  try {
    const session = JSON.parse(localStorage.getItem(LOGIN_SESSION_STORAGE_KEY) || 'null');
    return isLoginSession(session) ? session : null;
  } catch {
    return null;
  }
};

export const getRequestSession = (token: string | null): LoginSession | null => {
  const session = getLoginSession();
  return session && session.subject === getTokenSubject(token) ? session : null;
};

export const startLoginSession = (accessToken: string): LoginSession | null => {
  const subject = getTokenSubject(accessToken);
  if (!subject) return null;
  const generation = Array.from(crypto.getRandomValues(new Uint32Array(4)), value => value.toString(16)).join('-');
  const session = { subject, generation };
  localStorage.setItem(LOGIN_SESSION_STORAGE_KEY, JSON.stringify(session));
  return session;
};

// Bootstrap existing logins once; token refreshes keep the stored generation.
export const restoreLoginSession = (accessToken: string): LoginSession | null =>
  getRequestSession(accessToken) || startLoginSession(accessToken);
